import type { HubModule } from "core-fe-lib/components-shadcn/shell/types";
import { aiEmployeeRoutes } from "./routes";
import { getAIEmployeeLinks } from "./links";
import enUS from "./i18n/en-US";
import fr from "./i18n/fr";

export const AIEmployeeModule: HubModule = {
  id: "aiemployee",
  name: "AI Employee",
  requiredFeature: "aiemployee",
  landingPath: "/aiemployee/dashboard",
  landingPriority: 7,
  routes: (layouts) => aiEmployeeRoutes(layouts.MainLayout),
  navLinks: (ctx) => getAIEmployeeLinks(ctx.t),
  messages: { "en-US": enUS, fr },
};
